import { Injectable } from '@angular/core';
import { BehaviorSubject, } from "rxjs/BehaviorSubject";
import { Observable  } from "rxjs/Observable";
import { Subscriber } from "rxjs/Subscriber";
import { Subscription } from 'rxjs';

@Injectable()
export class UIEnvironmentService {
    currentPageTitle = process.env.config.title;

    setPageTitle(title: string): Observable<string> {
        var pageTitleEl = document.getElementsByTagName('title');
        // should be only one but for sure iterate
        Array.from(pageTitleEl).forEach((pt) => { (pt as HTMLTitleElement).innerText = title; });
        
        return Observable.from(title);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/ui-environment.service.ts